import { ActionReducerMap } from '@ngrx/store';
import { authReducer } from '../core/auth/store/auth.reducer';
import { userContextReducer } from '../core/user-context/store/user-context.reducer';
import { uiReducer } from './ui/ui.reducer';
import { AppState } from './app.state';

export const reducers: ActionReducerMap<AppState> = {
  auth: authReducer,
  userContext: userContextReducer,
  ui: uiReducer,
};
